/* eslint-disable jsx-a11y/anchor-is-valid */
import {useIntl} from 'react-intl'
import {useState} from 'react'
import {toast} from 'react-toastify'
import {DeleteConfirmationModal} from '../../../widgets/components/DeleteConfirmationModal'
import {deleteShareLinkId} from '../../core/_requests'
import useAllDataRooms from '../../../../hooks/getAllDataRoomsById'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../../hooks/gtmHelpers'
import {useAuth} from '../../../auth'

export function ShareLinkDropdown({
  isOpen,
  setMenuOpen,
  shareLinkId,
  setShareLinkShowModal,
  showShareLinkModal,
  getAllShareLinksByDataRoomId,
}: {
  isOpen: boolean
  setMenuOpen?: any
  shareLinkId?: number
  showShareLinkModal?: any
  setShareLinkShowModal?: any
  getAllShareLinksByDataRoomId: any
}) {
  const {formatMessage} = useIntl()
  const [deleteLoading, setDeleteLoading] = useState(false)
  const {getAllDataRoomsById} = useAllDataRooms()
  const {currentUser, companyId} = useAuth()

  const handleDeleteShareLink = async (shareLinkId: number) => {
    try {
      setDeleteLoading(true)
      if (shareLinkId) {
        const {
          data: {success, errors},
        } = await deleteShareLinkId(+shareLinkId)
        if (success) {
          setDeleteLoading(false)
          setShareLinkShowModal(false)
          toast.success(formatMessage({id: 'Share Link deleted successfully'}))
          getAllShareLinksByDataRoomId()
          getAllDataRoomsById()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteShareLinkSuccessful,
              action: 'normal',
              metadata: {
                share_link_id: shareLinkId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
        } else {
          setDeleteLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteShareLinkFailed,
              action: 'normal',
              metadata: {
                share_link_id: shareLinkId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setDeleteLoading(false)
      console.log(err)
    }
  }

  const handleOpenModal = () => {
    setShareLinkShowModal(true)
    setMenuOpen(false)
  }

  return (
    <>
      {isOpen ? (
        <div className='menu menu-sub menu-sub-dropdown data-room-option-dropdown-all-links show'>
          <div className='option-padding' onClick={handleOpenModal}>
            <p className='mb-0 text-danger'>{formatMessage({id: 'Delete Share Link'})}</p>
          </div>
        </div>
      ) : null}
      <DeleteConfirmationModal
        showDeleteModal={showShareLinkModal}
        setDeleteShowModal={setShareLinkShowModal}
        headingMessage={formatMessage({id: 'Delete Share Link'})}
        description={formatMessage({id: 'Are you sure you want to delete this Share Link?'})}
        handleDelete={handleDeleteShareLink}
        deleteLoading={deleteLoading}
        id={shareLinkId}
      />
    </>
  )
}
